var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0833 15.5C30.0833 23.5541 23.554 30.0833 15.5 30.0833C7.4458 30.0833 0.916626 23.5541 0.916626 15.5C0.916626 7.44584 7.4458 0.916668 15.5 0.916668C23.554 0.916668 30.0833 7.44584 30.0833 15.5ZM15.5 23.8854C16.104 23.8854 16.5937 23.3957 16.5937 22.7917V14.0417C16.5937 13.4376 16.104 12.9479 15.5 12.9479C14.8959 12.9479 14.4062 13.4376 14.4062 14.0417V22.7917C14.4062 23.3957 14.8959 23.8854 15.5 23.8854ZM15.5 8.20833C16.3054 8.20833 16.9583 8.86126 16.9583 9.66667C16.9583 10.4721 16.3054 11.125 15.5 11.125C14.6945 11.125 14.0416 10.4721 14.0416 9.66667C14.0416 8.86126 14.6945 8.20833 15.5 8.20833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.324a86819cca989a8a46495ab089d6b1.svg";
export { ForwardRef as ReactComponent };